import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable, NgZone } from '@angular/core';
import { catchError, map, Observable, of } from 'rxjs';
import { environment } from '../../../environments/environment';
import { HistoryComponent } from '../../history/history.component';
import { MOCK_TASKS } from '../../history/mock-tasks';
import { IPraticaEvent } from '../../opening/i-pratica-event';
import { CmsField, ICmsField } from '../models/cms-field';
import { SseService } from './sse.service';

export interface Task {
  id: string;
  name: string;
  scope: 'SUBPROCESS' | 'SYSTEM';
  variables: any;
}

export type HistoryTask = Task & { variables: ICmsField[] };

@Injectable({
  providedIn: 'root',
})
export class TaskService {
  private readonly endpoint = `${environment.api}/camunda/api/v1/task`;
  constructor(
    private http: HttpClient,
    private sseService: SseService,
    private zone: NgZone
  ) {}

  list(processId: string, taskType: Task['scope']): Observable<Task[]> {
    return this.http
      .get<{ tasks: Task[] }>(`${this.endpoint}/${processId}`)
      .pipe(
        map((response) =>
          response.tasks.filter((task) => task.scope === taskType)
        ),
        catchError((err) => {
          console.log(err);
          return of([]);
        })
      );
  }

  tasks(processId: string, idPratica: string): Observable<Task[]> {
    return this.http
      .get<{ tasks: Task[] }>(`${this.endpoint}/${processId}/${idPratica}`)
      .pipe(
        map((response) => response.tasks),
        catchError((err) => {
          console.log(err);
          return of([]);
        })
      );
  }

  execute(task: Task) {
    return this.http.post<{ task: '' }>(
      `${this.endpoint}/${task.id}`,
      task.variables
    );
  }
}
